<script setup lang="ts">
import NavigationBar from '@/shared/components/core/GlobalActionsPanel/components/NavigationBar/NavigationBar.vue';
import { useMainStore } from '@/core/store/main.ts';
import { storeToRefs } from 'pinia';

const { keyboardVisible } = storeToRefs(useMainStore());
</script>

<template>
  <div
    v-if="!keyboardVisible"
    class="navigation-wrapper"
  >
    <div class="navigation-bar-container">
      <NavigationBar />
    </div>
  </div>
</template>

<style scoped>
.navigation-wrapper {
  position: absolute;
  z-index: 15;
  bottom: var(--ion-safe-area-bottom);
  left: 8px;
  pointer-events: none;
}

.navigation-bar-container {
  width: calc(100vw - 16px);
  pointer-events: all;
}

@media all and (min-width: 601px) {
  .navigation-wrapper {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    pointer-events: all;
    bottom: 14px;
  }

  .navigation-bar-container {
    width: auto;
  }
}
</style>
